module.exports = __webpack_public_path__ + "static/media/mason.2c6fcc4d.svg";